import { type ReactNode } from 'react';
import { DataTable } from '~/shared/data-tables/DataTable';
import { type OrderViewModel } from '@generated';
import { useNavigate } from 'react-router-dom';
import type { DataTableColumnProps } from '~/shared/data-tables/DataTableColumn';
import { TableActions } from '~/shared/data-tables/TableActions';

function RenderActionsCell(props: OrderViewModel) {
	const navigate = useNavigate();

	const navigateToOrder = () => {
		navigate(`../order/${props.id}`);
	};

	return (
		<TableActions>
			<TableActions.ViewButton onClick={navigateToOrder} />
		</TableActions>
	);
}

const columns: DataTableColumnProps<OrderViewModel>[] = [
	{
		header: 'Order Date',
		key: 'orderDate',
		renderCell: d => d.orderDate.toLocaleDateString()
	},
	{
		header: 'Physician',
		key: 'signingPhysician',
		renderCell: d => d.orderingPatientPhysician.physician.fullName
	},
	{
		header: 'Status',
		key: 'orderStatusLabel'
	},
	{
		header: 'Order Type',
		key: 'orderType',
		renderCell: d => d.orderTypeLabel
	},
	{
		header: 'Method',
		key: 'orderMethod',
		renderCell: d => d.orderMethodLabel
	},
	{
		header: 'Signing Clinician',
		key: 'signingClinician',
		renderCell: d => d.signingClinician?.fullName ?? 'N/A'
	},
	{
		header: 'Clinician Signed On',
		key: 'clinicianSignedOn',
		renderCell: d => (d.clinicianSignedOnUtc ? d.clinicianSignedOnUtc.toLocaleString() : 'N/A')
	},
	{
		header: 'Created',
		key: 'dateCreated',
		renderCell: d => d.dateCreated.toLocaleString()
	},
	{
		key: 'actions',
		header: 'Actions',
		width: 'w-24',
		renderCell: d => <RenderActionsCell {...d} />
	}
];

export function OrdersTable({ rows, renderRowDetail }: { rows: OrderViewModel[]; renderRowDetail?: (row: OrderViewModel) => ReactNode }) {
	const sorted = rows.toSorted((a, b) => a.dateCreated.getTime() - b.dateCreated.getTime());
	return (
		<DataTable
			columns={columns}
			rows={sorted}
			getRowNotes={!renderRowDetail ? x => x.notes ?? null : undefined}
			renderRowDetail={renderRowDetail ? row => renderRowDetail(row) : undefined}
		/>
	);
}
